<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <div>
            <q-btn
              @click="showFilters();"
              :text-color="hideFilters ? 'grey-5' : 'white'"
              class="neutral-btn ctrl-button btn-compact"
              :class="{ primary: !hideFilters }"
              icon="filter_list"
              :icon-right="hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            />
          </div>
          <!-- Searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input
              :disable="!hideFilters || activeFilters"
              color="grey-5"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="getString('module.coupon.list.filter.general')"
            />
          </div>
        </div>
      </div>
      <!-- Invite button -->
      <div class="col-6" style="justify-content: flex-end">
        <q-btn v-if="$store.state.meStore.me.rights.includes('coupon.add')"
          class="capitalize ctrl-button right"
          color="ctrl-turquoise"
          :label="getString('action.add')"
          @click="$router.push('/coupon/add')"
          icon-right="add"
        />
      </div>
    </div>
    <!-- Filters block -->
    <transition name="fade">
    <div v-if="!hideFilters" class="table-block q-mb-md">
      <div class="row q-pa-md" style="justify-content: space-between;">
        <!-- Searchfield -->
        <div class="col-6 q-pa-md">
          <q-input color="primary"
            v-model="filters.code"
            @input="applyFilters"
            float-label="Code"/>
        </div>
      </div>
      <div class="row q-pa-md" style="justify-content: space-between;">
        <div class="q-pa-md" style="vertical-align: middle;">
          <q-btn
            :disable="!activeFilters"
            @click="resetFilters()"
            class="capitalize ctrl-button"
            :color="activeFilters ? 'primary' : 'grey-4'"
            label="Reset"
          />
        </div>
      </div>
    </div>
    </transition>
    <table-overview
      endpoint="coupon"
      :responseFormat="'coupons'"
      :columns="columns"
      permission="coupon"
      module="coupon"
      :selectable="false">
    </table-overview>
  </div>
</template>

<script>
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

// Components
import TableOverview from '@/components/overview/TableOverview.vue';

export default {
  mixins: [
    filtersMixin,
  ],
  components: {
    TableOverview,
  },
  data() {
    return {
      isLoading: false,
      columns: [
        {
          name: '__slot:coupon-code',
          title: 'Code',
          sortField: 'code',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
        },
        {
          name: 'type',
          title: 'Type',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
          callback: (type) => {
            let typeString;
            switch (type) {
              case 'discount_percent':
                typeString = 'Discount percent';
                break;
              case 'discount_euro':
                typeString = 'Discount euro';
                break;
              case 'sweepstake':
                typeString = 'Sweepstake';
                break;

              default:
                break;
            }
            return typeString;
          },
        },
        {
          name: '__slot:coupon-start',
          title: getString('datetime.label'),
          sortField: 'datetime',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m text-ellipsis',
          callback: 'tableFormatTime',
        },
        {
          name: '__slot:coupon-end',
          title: getString('datetime.label'),
          sortField: 'datetime',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m text-ellipsis',
          callback: 'tableFormatTime',
        },
      ],
      filters: {
        name: '',
      },
      searchTerm: '',
      hideFilters: true,
    };
  },
  methods: {
    getString,
  },
  computed: {
    checkboxActive() {
      return this.filters.active ? 'primary' : 'grey-4';
    },
  },
};
</script>
